module.exports = __webpack_public_path__ + "img/1.356ed5ff.png";